var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderListPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 35,
    viewBox: "0 0 49 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7909_1825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.374 20.9987L24.2148 30.5191C21.7754 33.363 18.219 35 14.47 35H12.8331C11.9985 35 11.4336 34.1462 11.761 33.3758L17.0635 20.9987H9.00706C6.65753 20.9987 4.52625 19.6121 3.55049 17.3523L0.0518657 6.18213C-0.185656 5.43103 0.37926 4.66709 1.16244 4.66709H4.07689C6.84369 4.66709 9.42433 6.06658 10.8816 8.31988L13.4108 11.6645L38.5303 11.6453C42.0996 11.4848 45.5725 12.8457 48.0568 15.3879C49.3407 16.704 49.3022 18.8032 47.9734 20.0743C47.3507 20.6649 46.5226 20.9987 45.6624 20.9987H32.374ZM17.1791 9.33419L14.0849 1.5985C13.7767 0.834556 14.3417 0 15.1698 0H17.3331C20.7355 0 24.003 1.35455 26.4103 3.76192L31.9824 9.33419H17.1791Z",
    fill: "#6A6A6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7909_1825"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderListPlane);
export default __webpack_public_path__ + "static/media/orderList-plane.72d7038f8818ed8edf6b1f1cd98be9b4.svg";
export { ForwardRef as ReactComponent };